import styled from 'styled-components'

export const FullWidthImageContainer = styled.div`
  display: flex;
  margin: 0 -${(props) => props.theme.spacing.lg};
`
